export enum ActivityTypeCode {
  GiftMember, // 0-购买会员赠送会员（效果图仅有）
  RechargeGift, // 1-充值赠送（券、会员）
  QingCloudGift, // 2-青云赠送（动画仅有）
  LuckyDrawGift, // 3-抽奖券（仅用于年中/年末活动）（国内动画仅有）
  Desktop, // 4-云制作币（动画仅有）
}

export enum CouponTypeCode {
  GPU = 1, // GPU券
  CPU, // CPU券
  Universal, // 通用券
  CPUQingCloud, // CPU青云券
  GPUQingCloud = 6, // GPU青云券
  Desktop = 8, // 云制作币
}

// 赠送方式 0按金额1按比例
export enum PresentTypeCode {
  Amount,
  Proportion,
}

// 赠送方式 0单笔充值 1累计充值
export enum RechargeTypeCode {
  SingleRecharge,
  SumRecharge,
}

export enum RedeemStatus {
  Unavailable,
  Awarded,
  OutstandingPrize,
}

export const PrizeLevelContent = Object.freeze({
  1: { cnName: "一", enName: "First " },
  2: { cnName: "二", enName: "Second " },
  3: { cnName: "三", enName: "Third " },
  4: { cnName: "四", enName: "Four " },
  5: { cnName: "五", enName: "Fifth " },
  6: { cnName: "六", enName: "Sixth " },
  7: { cnName: "七", enName: "Seventh " },
});

export const MonthTranslateContent = Object.freeze({
  1: "January",
  2: "February",
  3: "March",
  4: "April",
  5: "May",
  6: "June",
  7: "July",
  8: "August",
  9: "September",
  10: "October",
  11: "November",
  12: "December",
});

export enum WelfareType {
  INVITED_WELFARE = "invitedWelfare",
  NEWUSER_WELFARE = "newUserWelfare",
  PROPRIETARY_WELFARE = "proprietaryWelfare",
  FIRST_RECHARGE_WELFARE = "fistRechargeWelfare",
  OLDUSER_COMEBACK_WELFARE = "oldUserComebackWelfare",
}
